
<ng-container *ngIf="helpText$ | async as helpText">
<button type="button" mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
	 (click)="openMenu()"
	[disabled]="!this.hasPermission && !((helpText?.footer?.text)||(helpText?.header?.text)||(helpText?.bodies?.length))">
	<mat-icon>info</mat-icon>
</button><!-- [color]="primary"-->

<mat-menu class="padding-horizontal-sm" #menu="matMenu">
	<div (click)="$event.stopPropagation()" class="overflow-hidden">
		 <preview-help-text [helpText]="helpText"></preview-help-text> 

		<button *ngIf="hasPermission" mat-raised-button color="primary" (click)="openDialogEdit(helpText)"
			matTooltip="Edit Help Text">Edit</button>
	</div>
</mat-menu>
</ng-container>

